import { render } from "./ThemeSwitchComponent.vue?vue&type=template&id=042b64ca&scoped=true"
import script from "./ThemeSwitchComponent.vue?vue&type=script&lang=js"
export * from "./ThemeSwitchComponent.vue?vue&type=script&lang=js"

import "./ThemeSwitchComponent.vue?vue&type=style&index=0&id=042b64ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042b64ca"]])

export default __exports__